import { Model, fk, many, attr } from "redux-orm";
import { NaeSSchemaMap } from "../config/NaeSSchema";

class ProjectModel extends Model {
  static reducer(action, ProjectModel, session) {
    switch (action.type) {
      case "UPSERT_" + NaeSSchemaMap.Project.schema:
        action.payload.forEach((payload) => {
          const dbData = ProjectModel.withId(payload.id);

          const upsertData = payload;
          if (dbData) {
            const keys = Object.keys(upsertData);
            let needChange = false;
            keys.map((key) => {
              if (
                JSON.stringify(upsertData[key]) !== JSON.stringify(dbData[key])
              ) {
                needChange = true;
              }
            });

            if (!needChange) {
              return;
            }
          }

          ProjectModel.upsert(payload);
        });
        break;
    }
    // Return value is ignored.
    return session.state;
  }

  toString() {
    return this.id;
  }
  // Declare any static or instance methods you need.
}
ProjectModel.modelName = "ProjectModel";

ProjectModel.fields = {
  id: attr(),
};

export default ProjectModel;